export const getMuiAlignment = (value) => {
    switch (value) {
        case 'leading':
            return 'left';
        case 'center':
            return 'center';
        case 'trailing':
            return 'right';
        default:
            return 'left';
    }
};
//# sourceMappingURL=utils.js.map